<pc-nh-navbar></pc-nh-navbar>
<header>
    <h1></h1>
    <h3></h3>
</header>

<div class="explainer">
    <div class="grid-system">
        <img src="" alt="">
        <img src="" alt="">
    </div>

    <div>
        <h1>Actividade desportivas</h1>
        <div class="paragraph">
            <p>
                kulonga é uma e-learn que permita que você continue os seus estudos onde
            </p>
            <p>quer que estejes.em casa .no carro,em qualquer lugar desde que uses um </p>
            <p>smartphone ou um laptop</p>
        </div>
    </div>

    <div>
        <h1>Palestras e outros eventos</h1>
        <section class="news">
        <div class="articles">
            <article>
                <img src="" alt="article photo loading">
            </article>

            <div class="paragraph">
                <p>
                    kulonga é uma e-learn que permita que você continue os seus estudos onde
                </p>
                <p>quer que estejes.em casa .no carro,em qualquer lugar desde que uses um </p>
                <p>smartphone ou um laptop</p>
            </div>
        </div>

        <div class="articles">
            <article>
                <img src="" alt="article photo loading">
            </article>

            <div class="paragraph">
                <p>
                    kulonga é uma e-learn que permita que você continue os seus estudos onde
                </p>
                <p>quer que estejes.em casa .no carro,em qualquer lugar desde que uses um </p>
                <p>smartphone ou um laptop</p>
            </div>
        </div>

        <div class="articles">
            <article>
                <img src="" alt="article photo loading">
            </article>

            <div class="paragraph">
                <p>
                    kulonga é uma e-learn que permita que você continue os seus estudos onde
                </p>
                <p>quer que estejes.em casa .no carro,em qualquer lugar desde que uses um </p>
                <p>smartphone ou um laptop</p>
            </div>
        </div>
  
    </section>
    </div>
</div>

<footer>
    <div class="flex-footer">
    
            <div class="1st">
                <h5>Soluções</h5>
                <div class="uls">
                    <li><a href="#">Kulonga Skills</a></li>
                    <li><a href="#">Kulonga Flow</a></li>
                    <li><a href="#">Gift of Kulonga</a></li>
                    <li><a href="#">View Pricing</a></li>
                    <li><a href="#">Contact Sales</a></li>
                    
                </div>
            </div>
    
            <div class="1st">
                <h5>Plataformas</h5>
                <div class="uls">
                    <li><a href="">Browse library</a></li>
                    <li><a href="">Kulonga Tests</a></li>
                    <li><a href="">Kulonga cursos</a></li>
                    <li><a href="">Kulonga pro</a></li>
                </div>
            </div>
    
            <div class="1st">
                <h5>Recursos</h5>
                <div class="uls">
                    <li><a href="">Dribbble Kulong</a></li>
                    <li><a href="">Streamline.io icons</a></li>
                    <li><a href="">Kulonga Server CI CD</a></li>
                    <li><a href="">pc-nh.js library</a></li>
                    <li><a href="">pc-nh.css libray</a></li>
                    <li><a href="">Authored by pc-nh.js owner</a></li>
                </div>
            </div>
    </div>
    
    <div class="follow">
        <div>
            <img src="../assets/img/kulonga-small.png"  width="50" class="logo" alt="">
            <h5>Copyright © 2020 Kulonga E-learn. All rights reserved
            </h5>
            <h5>Termos de politica</h5>
            <h5>Politica de privacidade</h5>
        </div>
    </div>
        </footer>